/**
 * @format
 * @description Sponsored video page (without special meta keyword)
 */
export default {
  // available-slots-for-tier: {
  //   btyb: []
  // },
  mobile: {
    btyb: [[160, 30]]
  },
  portrait: {
    btyb: [[160, 30]]
  },
  landscape: {
    btyb: [[160, 30]]
  },
  desktop: {
    btyb: [[160, 30]]
  }
};
